import { css } from '@emotion/react'

import Colors from '../theme/Colors'
import { getAcronym } from './AcronymGenerator'

export default function Avatar(props: { photo?: string; title?: string }) {
  if (props.photo) {
    return <AvatarPhoto photo={props.photo} title={props.title} />
  }

  return <AvatarText title={props.title} />
}

function AvatarText(props: { title?: string }) {
  return (
    <div
      css={css`
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background: ${props.title ? Colors.Gray50 : Colors.Gray200};
        color: ${Colors.Gray400};
        font-weight: 600;
        font-size: 16px;
        line-height: 40px;
        width: 40px;
        height: 40px;
        user-select: none;
      `}
    >
      {props.title ? getAcronym(props.title) : ''}
    </div>
  )
}

function AvatarPhoto(props: { photo: string; title?: string }) {
  return (
    <div
      css={css`
        position: relative;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: white;

        & > img {
          display: block;
          width: 100%;
          height: 100%;
          -o-object-fit: cover;
          object-fit: cover;
        }
      `}
    >
      <img src={props.photo} alt={props.title} />
    </div>
  )
}
